var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"parking"}},[_c('TicketFilter',{on:{"submit-filters":_vm.getTickets}}),_c('Tickets',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRows),expression:"showRows"}],attrs:{"tickets":_vm.resultTickets},on:{"del-ticket":_vm.deleteTicket}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }